<template>
  <div class="setup-wizard-general-info">
    <p class="setup-wizard-general-info__title">Let's get started!</p>
    <template>
      <div v-for="input in filteredFields"
           :key="input.id"
           class="setup-wizard-general-info__input_wrapper"
           :class="[`setup-wizard-general-info__input_wrapper_${input.id}`, { 'setup-wizard-general-info__input_wrapper_error': errorFields[input.id] }]">
        <label class="setup-wizard-general-info__input_label" :for="input.id">{{ input.label }}</label>
        <input :type="input.type"
               :id="input.id"
               v-model="data[input.id]"
               :disabled="isDataUpdating"
               class="setup-wizard-general-info__input"
               :class="{ 'setup-wizard-general-info__input_error': errorFields[input.id] }"
               :placeholder="input.placeholder">
        <base-material-design-icon class="setup-wizard-general-info__input_icon" :icon="input.icon"/>
        <span v-if="errorFields[input.id]" class="setup-wizard-general-info__input_error-message">{{ errorFields[input.id] }}</span>
      </div>
    </template>
    <button :disabled="isDataUpdating"
            class="setup-wizard-general-info__submit"
            @click.prevent="onSubmit">
      NEXT
    </button>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

const FIELDS = [
  {
    id: 'agency',
    label: 'Company or Agency',
    placeholder: 'Enter your company or agency name',
    type: 'text',
    icon: 'domain'
  },
  {
    id: 'website',
    label: 'Project Website (Must be a fully-qualified URL)',
    placeholder: 'Enter the website for your project',
    type: 'text',
    icon: 'link'
  }
]
export default {
  name: 'GeneralInfo',
  data () {
    return {
      errorFields: {},
      isDataUpdating: false,
      data: {
        website: '',
        agency: ''
      }
    }
  },
  computed: {
    filteredFields () {
      return _.cloneDeep(FIELDS)
    }
  },
  methods: {
    ...mapActions('accountSetup', ['completeSetup']),
    ...mapActions('client', ['getClientsSettings']),
    ...mapActions(['getCurrentSession']),
    async onSubmit () {
      this.isDataUpdating = true
      
      // Store the data in Vuex for later use
      this.$store.commit('accountSetup/setGeneralInfo', {
        ...this.data,
        userId: this.currentUser._id
      })
      
      // Navigate to next step without creating project yet
      this.$router.push({ name: 'setup-wizard-locality-info' })
      this.isDataUpdating = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .setup-wizard-general-info {
    height: fit-content;
    width: 394px;
    margin: auto;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 6px 16px 0 rgba(96, 97, 112, 0.2), 0 1px 4px 0 rgba(40, 41, 61, 0.06);
    padding: 48px;

    &__submit {
      display: block;
      margin: 48px auto 0;
      outline: none;
      border: none;
      padding: 16px 59px;
      line-height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      background-color: $rfx-bright-turquoise;
      border-radius: 8px;

      &:disabled {
        pointer-events: none;
        opacity: .4;
      }
    }

    &__input {
      display: inline-block;
      width: -webkit-fill-available;
      line-height: 24px;
      border-radius: 8px;
      border: solid 1px #7c8e9b;
      padding: 16px 16px 16px 56px;
      color: $rfx-medium-march !important;
      margin: 1px;

      &:disabled {
        background-color: #7c8e9b40;
      }

      &::placeholder {
        color: $rfx-medium-march;
      }

      &:focus {
        border: 2px solid $rfx-bright-turquoise;
        outline: none;
        margin: 0;
      }

      &_error {
        border-color: $rfx-light-red;
      }

      &_error-message {
        display: inline-block;
        color: $rfx-light-red;
        margin-top: 8px;
        font-size: 14px;
        line-height: 16px;
      }

      &_wrapper {
        margin-bottom: 24px;

        &_error {
          margin-bottom: 16px;
        }

        &_confirm-password {
          margin-bottom: 0 !important;
        }
      }

      &_label {
        font-size: 14px;
        line-height: 16px;
        display: inline-block;
        font-weight: 500;
        color: $rfx-medium-march;
        margin-bottom: 8px;
      }

      &_icon {
        display: block;
        font-size: 24px;
        color: $rfx-medium-march;
        width: 0;
        height: 0;
        position: relative;
        left: 18px;
        top: -18px;
      }
    }

    &__title {
      margin: 0 0 16px;
      padding: 0;
      color: $rfx-dark-march;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
    }

  }

  @media only screen and (max-width: 490px) {
    .setup-wizard-general-info {
      width: -webkit-fill-available;
      min-height: -webkit-fill-available;
      padding: 24px 24px 32px;
      border-radius: 0;
      position: absolute;
      top: 0;
      display: flex;
      flex-direction: column;

      &__title {
        font-size: 24px;
        font-weight: bold;

        &_sign-in {
          margin-top: auto;
        }
      }

      &__input {
        &_wrapper {
          margin-bottom: 16px;
        }
      }

      &__submit {
        margin-top: 24px;

        &_sign-in {
          margin-top: 32px;
          margin-bottom: auto;
        }
      }
    }
  }
</style>
